import axios from 'axios'

const get = () => {
    const config = {
        headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
        }
    }
    return axios.get('/api/setting', config)
}

const settingAPI = { get }
export default settingAPI